import { safeString } from "../../helpers";
export function getBetTrackedData(retriever, betId) {
    const bet = retriever.bets.get(betId);
    const betType = safeString(bet === null || bet === void 0 ? void 0 : bet.type);
    const isSGPExtra = bet === null || bet === void 0 ? void 0 : bet.selections.some(s => s.nestedSGPSelections);
    const enhancedType = isSGPExtra ? "SGPExtra" : "None";
    return {
        BetType: betType,
        EnhancedType: enhancedType,
    };
}
//# sourceMappingURL=getBetTrackedData.js.map